/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_CaribbeanInputs */

const bn_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যারিবিয়ান`)
};

const de_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karibik`)
};

const el_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καραϊβική`)
};

const en_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caribbean`)
};

const es_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caribe`)
};

const fr_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caraïbes`)
};

const hi_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैरेबियन`)
};

const hu_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karib-térség`)
};

const id_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karibia`)
};

const it_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caraibico`)
};

const ja_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カリブ海`)
};

const ko_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카리브해`)
};

const nl_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caribisch gebied`)
};

const pl_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karaiby`)
};

const pt_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caribe`)
};

const ru_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карибский бассейн`)
};

const sv_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karibien`)
};

const tr_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karayipler`)
};

const uk_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карибський басейн`)
};

const vi_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vùng Caribe`)
};

const zh_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加勒比海`)
};

const zh_hant_geo_label_caribbean = /** @type {(inputs: Geo_Label_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加勒比海`)
};

/**
* | output |
* | --- |
* | "Caribbean" |
*
* @param {Geo_Label_CaribbeanInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_caribbean = /** @type {((inputs?: Geo_Label_CaribbeanInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_CaribbeanInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_caribbean(inputs)
	if (locale === "de") return de_geo_label_caribbean(inputs)
	if (locale === "el") return el_geo_label_caribbean(inputs)
	if (locale === "en") return en_geo_label_caribbean(inputs)
	if (locale === "es") return es_geo_label_caribbean(inputs)
	if (locale === "fr") return fr_geo_label_caribbean(inputs)
	if (locale === "hi") return hi_geo_label_caribbean(inputs)
	if (locale === "hu") return hu_geo_label_caribbean(inputs)
	if (locale === "id") return id_geo_label_caribbean(inputs)
	if (locale === "it") return it_geo_label_caribbean(inputs)
	if (locale === "ja") return ja_geo_label_caribbean(inputs)
	if (locale === "ko") return ko_geo_label_caribbean(inputs)
	if (locale === "nl") return nl_geo_label_caribbean(inputs)
	if (locale === "pl") return pl_geo_label_caribbean(inputs)
	if (locale === "pt") return pt_geo_label_caribbean(inputs)
	if (locale === "ru") return ru_geo_label_caribbean(inputs)
	if (locale === "sv") return sv_geo_label_caribbean(inputs)
	if (locale === "tr") return tr_geo_label_caribbean(inputs)
	if (locale === "uk") return uk_geo_label_caribbean(inputs)
	if (locale === "vi") return vi_geo_label_caribbean(inputs)
	if (locale === "zh") return zh_geo_label_caribbean(inputs)
	return zh_hant_geo_label_caribbean(inputs)
});